import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

const dayJs = (date?: string | Date | dayjs.Dayjs) => {
    dayjs.locale('pt-br')
    dayjs.extend(utc)
    // dayjs.extend(timezone)
    // dayjs.tz.setDefault('America/Sao_Paulo')
    // dayjs.extend(weekday)

    if (date) {
        return dayjs(date).locale('pt-br')
    }

    return dayjs().locale('pt-br')
}

export const dayjsTimezoneBrazil = (date?: string | Date | dayjs.Dayjs) => {
    dayjs.locale('pt-br')
    dayjs.extend(utc)
    dayjs.extend(timezone)
    dayjs.tz.setDefault('America/Sao_Paulo')
    // dayjs.extend(weekday)

    if (date) {
        return dayjs(date).tz('America/Sao_Paulo').locale('pt-br')
    }

    return dayjs().tz('America/Sao_Paulo').locale('pt-br')
}

export default dayJs
